const adaptProjectImageResponseData = data => ({
	...data,
	url: `${data.url}?${new Date().getTime()}`,
	thumbnailUrl: `${data.thumbnailUrl}?${new Date().getTime()}`,
});

export default adaptProjectImageResponseData;
